import { Scale, Briefcase, FileCheck2, ArrowUpRight } from "lucide-react";

const SERVICIOS = [
  {
    icon: Scale,
    title: "Asesoría fiscal y patrimonial",
    text: "Planeación fiscal a la medida, blindaje patrimonial, optimización tributaria con apego pleno a la normativa SAT 2026.",
    color: "var(--rp-blue)",
    bg: "rgba(71, 118, 185, 0.08)",
    image: "https://customer-assets.emergentagent.com/job_rp-profesional/artifacts/kqw3ftrh_asesoria-fiscal.jpg",
  },
  {
    icon: Briefcase,
    title: "Gobierno corporativo y consejería",
    text: "Instalación de consejos consultivos y de administración, protocolos familiares, sucesión, profesionalización de la empresa familiar.",
    color: "var(--rp-green)",
    bg: "rgba(50, 138, 87, 0.08)",
    image: "https://customer-assets.emergentagent.com/job_rp-profesional/artifacts/ibjgbc9d_gobierno-corporativo.jpg",
  },
  {
    icon: FileCheck2,
    title: "Asesoría contable, financiera y de cumplimiento",
    text: "Estados financieros, KPIs, cumplimiento mensual, devoluciones de impuestos, dictamen, nómina y seguridad social.",
    color: "var(--rp-teal)",
    bg: "rgba(0, 191, 165, 0.08)",
    image: "https://customer-assets.emergentagent.com/job_rp-profesional/artifacts/6pg85c3k_asesoria-financiera.jpg",
  },
];

export default function Servicios() {
  return (
    <section id="servicios" data-testid="servicios-section" className="py-20 sm:py-28 bg-white relative">
      <div className="rp-container">
        <div className="rp-reveal max-w-3xl">
          <span className="rp-kicker rp-kicker-green">Servicios</span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight" style={{ color: "var(--rp-ink)" }}>
            Una práctica integral para empresarios, socios y familias empresariales.
          </h2>
        </div>

        <div className="mt-14 grid lg:grid-cols-3 gap-6">
          {SERVICIOS.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={i}
                data-testid={`service-card-${i}`}
                className="rp-card rp-service-card rp-reveal flex flex-col overflow-hidden"
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                  />
                  <div
                    className="absolute inset-0"
                    style={{
                      background:
                        "linear-gradient(180deg, rgba(60,57,80,0) 40%, rgba(60,57,80,0.5) 100%)",
                    }}
                  />
                  <div
                    className="absolute top-4 left-4 w-12 h-12 rounded-2xl flex items-center justify-center backdrop-blur-md"
                    style={{ background: s.bg, border: `1px solid ${s.color}33` }}
                  >
                    <Icon className="w-6 h-6" style={{ color: s.color }} />
                  </div>
                </div>
                <div className="p-8 flex flex-col flex-1">
                  <h3 className="text-xl font-bold leading-snug mb-4" style={{ color: "var(--rp-ink)" }}>
                    {s.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed text-sm flex-1">{s.text}</p>
                  <a
                    href="#contacto"
                    className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold group/link"
                    style={{ color: s.color }}
                  >
                    Consultar
                    <ArrowUpRight className="w-4 h-4 transition-transform group-hover/link:translate-x-1 group-hover/link:-translate-y-1" />
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
